module.exports = __webpack_public_path__ + "img/intensive-conqueror.4900538a.png";